import {createAction} from '@reduxjs/toolkit';

import {getMosaicById} from '@explorer/api/mosaics';
import {COMPARE_TYPES} from '@explorer/constants';
import {enhancedMosaic} from '@explorer/util/mosaics';

export const setCompareMethod = createAction('SET_COMPARE_METHOD');

export const setCompareSubject = createAction('SET_COMPARE_SUBJECT');

export const setCompareSubjects = createAction('SET_COMPARE_SUBJECTS');

export const swapCompareSubjects = createAction('SWAP_COMPARE_SUBJECTS');

export const clearCompareSubjects = createAction('CLEAR_COMPARE_SUBJECTS');

export const loadCompareSubjects = subjects => (dispatch, getState) => {
  const {series} = getState();

  // Ensure we have loaded all the right info for basemaps
  // This is needed specially when basemaps of different series were compared
  // We don't do results/scenes here because they will be loaded by the worker-manager separately
  Object.entries(subjects).forEach(async ([index, subject]) => {
    if (subject?.type === COMPARE_TYPES.MOSAIC) {
      const subjectSeries = series.byId[subject.parent];

      // user has access to this series/mosaic
      if (subjectSeries) {
        const mosaic = await getMosaicById(subject.id);

        const newSubject = {
          ...subject,
          item: {
            ...enhancedMosaic(mosaic),
            seriesId: subjectSeries.id,
            seriesName: subjectSeries.name,
          },
        };
        dispatch(setCompareSubject({index, subject: newSubject}));
      }
    } else {
      dispatch(setCompareSubject({index, subject: subjects[index]}));
    }
  });
};
